import {
  PUBLIC_SHORT_DATED_SLUG,
  PUBLIC_SHORT_DATED_SLUG_EN,
  PUBLIC_SHORT_DATED_SLUG_FI,
  PUBLIC_SHORT_DATED_SLUG_NB,
  PUBLIC_SHORT_DATED_SLUG_SV,
  PUBLIC_SHORT_DATED_SLUG_DA,
  PUBLIC_SHORT_DATED_SLUG_ES
} from '$env/static/public';

export const getShortDatedSlug = (locale: string) => {
  switch (locale) {
    case 'en': return PUBLIC_SHORT_DATED_SLUG_EN;
    case 'fi': return PUBLIC_SHORT_DATED_SLUG_FI;
    case 'no':
    case 'nb': return PUBLIC_SHORT_DATED_SLUG_NB;
    case 'sv': return PUBLIC_SHORT_DATED_SLUG_SV;
    case 'da': return PUBLIC_SHORT_DATED_SLUG_DA;
    case 'es': return PUBLIC_SHORT_DATED_SLUG_ES;
    default: return PUBLIC_SHORT_DATED_SLUG;
  }
};
